module.exports = __webpack_public_path__ + "img/logo.7fcc20a6.png";